import { createApp } from 'vue'
import ROIReport from "@/components/ROIReport.vue"
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'


createApp(ROIReport).use(Quasar, quasarUserOptions).use(Quasar, quasarUserOptions).mount('#roiReport')